/** The Sketchling logo: a star traced by a pencil (landing, onboarding, account). */
import type { CSSProperties } from 'react';

const STAR = 'M60 12 L72 46 L108 46 L79 67 L90 102 L60 81 L30 102 L41 67 L12 46 L48 46 Z';

/** Our logo: a pencil tip travels around and leaves a five-point star behind, plus the word mark. */
export function Logo({ size = 64, wordmark = true }: { size?: number; wordmark?: boolean }) {
  return (
    <div className="sk-logo" aria-label="Sketchling" role="img">
      <svg width={size} height={size} viewBox="0 0 120 120" aria-hidden>
        <circle cx="60" cy="60" r="56" fill="#15394A" />
        <path className="sk-logo-star" d={STAR} pathLength={1} fill="none" stroke="#FFC23A" strokeWidth="7" strokeLinejoin="round" strokeLinecap="round" />
        <g className="sk-logo-pencil" style={{ offsetPath: `path('${STAR}')` } as CSSProperties}>
          <g transform="rotate(-45) translate(-4 -30)">
            <rect x="0" y="0" width="8" height="22" rx="1.5" fill="#FF7A1A" stroke="#132630" strokeWidth="2" />
            <path d="M0 22 L4 30 L8 22 Z" fill="#FFFBF4" stroke="#132630" strokeWidth="2" strokeLinejoin="round" />
            <path d="M2.6 27.2 L4 30 L5.4 27.2 Z" fill="#132630" />
          </g>
        </g>
      </svg>
      {wordmark && <span className="sk-logo-word">Sketchling</span>}
    </div>
  );
}

